import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';
import { ContainerInfo } from './types';

type GetContainerListArgs = {
  porSlot: boolean;
  codViaje: number;
};

type GetContainerListResponse = {
  state: number;
  value: ContainerInfo[];
};

export const getContainerList = async ({
  porSlot,
  codViaje,
}: GetContainerListArgs): Promise<ContainerInfo[]> => {
  try {
    const res = await apiClient.post<GetContainerListResponse>(
      Endpoints.ContainerList,
      {
        porSlot,
        codViaje,
      }
    );
    return res.data.value;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.message);
    }
    throw error;
  }
};
